import { useRef } from 'react';

/**
 * @description useConstructor Hook which simulates constructor. It gets called before mount.
 * @param {function} func Function to execute
 */

// eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-empty-function
const useConstructor = (func: Function = () => { }): void => {
    const isInitialRender = useRef(true);
    const memoizedFuncValue = useRef();

    if (isInitialRender.current) {
        isInitialRender.current = false;
        memoizedFuncValue.current = func();
    }
    return memoizedFuncValue.current;
};

export default useConstructor;
